module.exports = __webpack_public_path__ + "static/img-blood-donation-89f91a85a84ec2666adc1fe0ba6be536.jpg";